export default "__VITE_ASSET__DTHz43Ou__"